<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskLayout> in <template>
import KioskLayout from '@/app/layouts/kiosk/KioskLayout.vue';
// biome-ignore lint/correctness/noUnusedImports: used in <template>
import { router } from '@/app/router';
import exposeToGlobalScope from '@/shared/utils/expose-to-global-scope';
// biome-ignore lint/correctness/noUnusedImports: used via tag <UiNumericKeyboard> in <template>
import { UiNumericKeyboard } from '@/ui-kit';
import { useVoucherValidation } from './terminal/useVoucherValidation';

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const { t } = useI18n();
const {
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  onInvalidAttempt,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  onPinKeyboardClose,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  onPinSuccess,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  pinCode,
  publicApi,
} = useVoucherValidation();

onMounted(() => {
  exposeToGlobalScope(publicApi, 'PaymentVoucher');
});

defineExpose(publicApi);
</script>

<template>
  <KioskLayout :is-centered="true">
    <div class="PaymentVoucher" data-testid="payment-voucher-root">
      <UiNumericKeyboard
        :clear-label="t('NumericKeyboard.clear')"
        :enter-label="t('NumericKeyboard.enter')"
        :error-message="t('NumericKeyboard.invalidPin')"
        :pin="pinCode"
        :title="t('PaymentVoucher.pinTitle')"
        @close="onPinKeyboardClose"
        @error="onInvalidAttempt"
        @success="onPinSuccess"
      />

      <div class="PaymentVoucher__footer">
        <RouterLink
          class="kiosk-button"
          data-testid="payment-voucher-back"
          :to="router.getLinkToStep('payment-type')"
        >
          {{ t('PaymentVoucher.buttonBack') }}
        </RouterLink>
      </div>
    </div>
  </KioskLayout>
</template>

<style scoped lang="scss">
.PaymentVoucher {
  max-width: 50rem;
}

.PaymentVoucher__footer {
  display: flex;
  justify-content: center;
  margin-top: 2.4rem;
}
</style>
